// DO NOT EDIT!!! This file is auto-generated.

import ar from './locales/ar.json';
import cs from './locales/cs.json';
import da from './locales/da.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import he from './locales/he.json';
import hi from './locales/hi.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import nb from './locales/nb.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import zh_CN from './locales/zh-CN.json';
import zh_TW from './locales/zh-TW.json';

type PhraseLocales =
  | 'ar'
  | 'cs'
  | 'da'
  | 'de'
  | 'en'
  | 'es'
  | 'fi'
  | 'fr'
  | 'he'
  | 'hi'
  | 'it'
  | 'ja'
  | 'ko'
  | 'nb'
  | 'nl'
  | 'sv'
  | 'zh-CN'
  | 'zh-TW';
export type LocaleTextJson = Record<MessageKey, string>;
type Messages = Record<PhraseLocales, LocaleTextJson>;
export const MESSAGES: Messages = {
  ar: ar,
  cs: cs,
  da: da,
  de: de,
  en: en,
  es: es,
  fi: fi,
  fr: fr,
  he: he,
  hi: hi,
  it: it,
  ja: ja,
  ko: ko,
  nb: nb,
  nl: nl,
  sv: sv,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
};

// Export all keys for unused key detection
export const messageKeys = [
  'checkout_payment_3ds_error',
  'checkout_payment_authentication_error',
  'checkout_payment_avs_error',
  'checkout_payment_bank_rejected',
  'checkout_payment_captcha_error',
  'checkout_payment_fraud_suspected',
  'checkout_payment_funds_error',
  'checkout_payment_generic_error',
  'checkout_payment_generic_error_no_code',
  'checkout_payment_invalid_card_error',
  'checkout_payment_invalid_expiration_date',
  'checkout_payment_max_attempts',
  'country_AD',
  'country_AE',
  'country_AF',
  'country_AG',
  'country_AI',
  'country_AL',
  'country_AM',
  'country_AO',
  'country_AQ',
  'country_AR',
  'country_AS',
  'country_AT',
  'country_AU',
  'country_AW',
  'country_AX',
  'country_AZ',
  'country_BA',
  'country_BB',
  'country_BD',
  'country_BE',
  'country_BF',
  'country_BG',
  'country_BH',
  'country_BI',
  'country_BJ',
  'country_BL',
  'country_BM',
  'country_BN',
  'country_BO',
  'country_BQ',
  'country_BR',
  'country_BS',
  'country_BT',
  'country_BV',
  'country_BW',
  'country_BY',
  'country_BZ',
  'country_CA',
  'country_CC',
  'country_CD',
  'country_CF',
  'country_CG',
  'country_CH',
  'country_CI',
  'country_CK',
  'country_CL',
  'country_CM',
  'country_CN',
  'country_CO',
  'country_CR',
  'country_CU',
  'country_CV',
  'country_CW',
  'country_CX',
  'country_CY',
  'country_CZ',
  'country_DE',
  'country_DJ',
  'country_DK',
  'country_DM',
  'country_DO',
  'country_DZ',
  'country_EA',
  'country_EC',
  'country_EE',
  'country_EG',
  'country_EH',
  'country_ER',
  'country_ES',
  'country_ET',
  'country_FI',
  'country_FJ',
  'country_FK',
  'country_FM',
  'country_FO',
  'country_FR',
  'country_GA',
  'country_GB',
  'country_GD',
  'country_GE',
  'country_GF',
  'country_GG',
  'country_GH',
  'country_GI',
  'country_GL',
  'country_GM',
  'country_GN',
  'country_GP',
  'country_GQ',
  'country_GR',
  'country_GS',
  'country_GT',
  'country_GU',
  'country_GW',
  'country_GY',
  'country_HK',
  'country_HM',
  'country_HN',
  'country_HR',
  'country_HT',
  'country_HU',
  'country_IC',
  'country_ID',
  'country_IE',
  'country_IL',
  'country_IM',
  'country_IN',
  'country_IO',
  'country_IQ',
  'country_IR',
  'country_IS',
  'country_IT',
  'country_JE',
  'country_JM',
  'country_JO',
  'country_JP',
  'country_KE',
  'country_KG',
  'country_KH',
  'country_KI',
  'country_KM',
  'country_KN',
  'country_KP',
  'country_KR',
  'country_KW',
  'country_KY',
  'country_KZ',
  'country_LA',
  'country_LB',
  'country_LC',
  'country_LI',
  'country_LK',
  'country_LR',
  'country_LS',
  'country_LT',
  'country_LU',
  'country_LV',
  'country_LY',
  'country_MA',
  'country_MC',
  'country_MD',
  'country_ME',
  'country_MF',
  'country_MG',
  'country_MH',
  'country_MK',
  'country_ML',
  'country_MM',
  'country_MN',
  'country_MO',
  'country_MP',
  'country_MQ',
  'country_MR',
  'country_MS',
  'country_MT',
  'country_MU',
  'country_MV',
  'country_MW',
  'country_MX',
  'country_MY',
  'country_MZ',
  'country_NA',
  'country_NC',
  'country_NE',
  'country_NF',
  'country_NG',
  'country_NI',
  'country_NL',
  'country_NO',
  'country_NP',
  'country_NR',
  'country_NU',
  'country_NZ',
  'country_OM',
  'country_PA',
  'country_PE',
  'country_PF',
  'country_PG',
  'country_PH',
  'country_PK',
  'country_PL',
  'country_PM',
  'country_PN',
  'country_PR',
  'country_PS',
  'country_PT',
  'country_PW',
  'country_PY',
  'country_QA',
  'country_RE',
  'country_RO',
  'country_RS',
  'country_RU',
  'country_RW',
  'country_SA',
  'country_SB',
  'country_SC',
  'country_SD',
  'country_SE',
  'country_SG',
  'country_SH',
  'country_SI',
  'country_SJ',
  'country_SK',
  'country_SL',
  'country_SM',
  'country_SN',
  'country_SO',
  'country_SR',
  'country_SS',
  'country_ST',
  'country_SV',
  'country_SX',
  'country_SY',
  'country_SZ',
  'country_TC',
  'country_TD',
  'country_TF',
  'country_TG',
  'country_TH',
  'country_TJ',
  'country_TK',
  'country_TL',
  'country_TM',
  'country_TN',
  'country_TO',
  'country_TR',
  'country_TT',
  'country_TV',
  'country_TW',
  'country_TZ',
  'country_UA',
  'country_UG',
  'country_UM',
  'country_US',
  'country_UY',
  'country_UZ',
  'country_VA',
  'country_VC',
  'country_VE',
  'country_VG',
  'country_VI',
  'country_VN',
  'country_VU',
  'country_WF',
  'country_WS',
  'country_XI',
  'country_XK',
  'country_YE',
  'country_YT',
  'country_ZA',
  'country_ZM',
  'country_ZW',
  'hsa_fsa_banner_body_text',
  'hsa_fsa_banner_link_text',
  'inactive_prepaid_pending_membership_renew_go_to_membership_hub',
  'inactive_prepaid_pending_membership_renew_pill_title',
  'inactive_prepaid_pending_membership_renew_subtitle',
  'inactive_prepaid_pending_membership_renew_title',
  'low-memory-check-body',
  'low-memory-check-title',
  'membereship-close-address2-button',
  'membership_address_contains_restricted_characters',
  'membership_address_country_disabled_field',
  'membership_addressform_error_address1_missing',
  'membership_addressform_error_city_missing',
  'membership_addressform_error_country_missing',
  'membership_addressform_error_fieldname_address',
  'membership_addressform_error_fieldname_address2',
  'membership_addressform_error_fieldname_city',
  'membership_addressform_error_fieldname_country',
  'membership_addressform_error_fieldname_postalcode',
  'membership_addressform_error_fieldname_state',
  'membership_addressform_error_firstname_missing',
  'membership_addressform_error_general',
  'membership_addressform_error_incorrect_address',
  'membership_addressform_error_incorrect_city',
  'membership_addressform_error_incorrect_postalcode',
  'membership_addressform_error_invalid_postalcode_for_country',
  'membership_addressform_error_lastname_missing',
  'membership_addressform_error_missing_address',
  'membership_addressform_error_missing_city',
  'membership_addressform_error_missing_postalcode',
  'membership_addressform_error_state_missing',
  'membership_addressform_error_too_long',
  'membership_addressform_error_zipcode_invalid',
  'membership_addressform_error_zipcode_missing',
  'membership_data_privacy_page_link',
  'membership_error_agreement_required',
  'membership_error_email_not_found_for_cloudaccount',
  'membership_error_error_occured',
  'membership_error_exchange_token_jwt',
  'membership_error_failed_payment_signature_creation',
  'membership_error_getting_countries',
  'membership_error_getting_offerings',
  'membership_error_go_home_to_get_address_data',
  'membership_error_invalid_credit_card',
  'membership_error_invalid_credit_card_type',
  'membership_error_invalid_cvv',
  'membership_error_invalid_email',
  'membership_error_invalid_token_format',
  'membership_error_membership_addressvalidation_failed',
  'membership_error_missing_access_token',
  'membership_error_missing_dynamic_hosted_page_params',
  'membership_error_missing_email_hub',
  'membership_error_missing_email_signup_login',
  'membership_error_missing_payment_method_hub_login',
  'membership_error_missing_signup_token',
  'membership_error_missing_url',
  'membership_error_missing_usertype_from_offering',
  'membership_error_new_email_validation',
  'membership_error_no_product_found',
  'membership_error_no_recurring_fee_found',
  'membership_error_no_subscription_created',
  'membership_error_no_subscription_found',
  'membership_error_not_allowed_to_create_sub_without_entitlement',
  'membership_error_on_account_update',
  'membership_error_on_address_validation',
  'membership_error_on_change_subscription_plan',
  'membership_error_on_direct_renew_subscription',
  'membership_error_on_get_account',
  'membership_error_on_getting_offerings',
  'membership_error_on_renew_subscription',
  'membership_error_on_renew_subscription_renew_limit_reached',
  'membership_error_on_reset_password_token_missing',
  'membership_error_on_verify_email_magic_link_token_missing',
  'membership_error_onetime_token_used',
  'membership_error_page_not_found',
  'membership_error_page_you_are_looking_for_not_exists',
  'membership_error_password_requirements',
  'membership_error_required_field',
  'membership_error_unknown',
  'membership_footer_all_rights_reserved_dynamic',
  'membership_footer_trademarks',
  'membership_gen4_ring_text',
  'membership_hide_password',
  'membership_home_address',
  'membership_homepage_link',
  'membership_hub_accessibility_navigate_to',
  'membership_hub_account_information',
  'membership_hub_account_management',
  'membership_hub_add_new_address',
  'membership_hub_add_payment_method',
  'membership_hub_address_country_field_disabled_reason',
  'membership_hub_address_page_invalid_field',
  'membership_hub_address_page_sub_text',
  'membership_hub_address_page_title',
  'membership_hub_address_page_validation_error',
  'membership_hub_address_page_validation_general_error',
  'membership_hub_address_validation_suggestion_edit_entered_address',
  'membership_hub_address_validation_suggestion_entered_address_header',
  'membership_hub_address_validation_suggestion_header',
  'membership_hub_address_validation_suggestion_suggested_address_header',
  'membership_hub_address_validation_suggestion_text',
  'membership_hub_address_validation_suggestion_use_selected_address',
  'membership_hub_annual_report_pdf_file_name',
  'membership_hub_annual_report_zip_file_name',
  'membership_hub_b2b_partner_paid_by',
  'membership_hub_b2b_partner_plan_name',
  'membership_hub_b2b_plan_description',
  'membership_hub_b2c_no_subscription_no_access',
  'membership_hub_billing_address',
  'membership_hub_billing_history_header',
  'membership_hub_billing_information',
  'membership_hub_billing_payment_details',
  'membership_hub_billing_status',
  'membership_hub_billing_status_active',
  'membership_hub_billing_status_active_description_b2b_membership',
  'membership_hub_billing_status_active_description_lifetime_membership',
  'membership_hub_billing_status_active_description_next_payment_on',
  'membership_hub_billing_status_dormant_subscription',
  'membership_hub_billing_status_inactive',
  'membership_hub_billing_status_inactive_description_b2b_membership',
  'membership_hub_billing_status_non_matching_currency',
  'membership_hub_billing_status_payment_failed',
  'membership_hub_billing_status_payment_failed_description_dunning',
  'membership_hub_billing_status_payment_required',
  'membership_hub_billing_status_pending_cancellation',
  'membership_hub_billing_status_pending_cancellation_description',
  'membership_hub_billing_status_pending_prepaid',
  'membership_hub_billing_status_pending_prepaid_membership',
  'membership_hub_cancel_dialog_cancel_membership',
  'membership_hub_cancel_dialog_fine_print',
  'membership_hub_cancel_dialog_keep_my_membership',
  'membership_hub_cancel_dialog_learn_more',
  'membership_hub_cancel_dialog_subtile_first',
  'membership_hub_cancel_dialog_subtitle_second',
  'membership_hub_cancel_dialog_title_v2',
  'membership_hub_cancel_membership',
  'membership_hub_cancel_membership_disclaimer',
  'membership_hub_cancellation_modal_body_text_1_v2',
  'membership_hub_cancellation_modal_body_text_2_v2',
  'membership_hub_cancellation_modal_body_text_3_v2',
  'membership_hub_cancelled',
  'membership_hub_check_your_email',
  'membership_hub_choose_ongoing_plan_after_prepaid',
  'membership_hub_confirm_modal_plan_renew',
  'membership_hub_continue',
  'membership_hub_credit_card',
  'membership_hub_credit_months_remaining',
  'membership_hub_cta_update_payment_method',
  'membership_hub_current_plan_title',
  'membership_hub_data_export_available',
  'membership_hub_data_export_cta',
  'membership_hub_data_export_cta_send',
  'membership_hub_data_export_description',
  'membership_hub_data_export_download_failed',
  'membership_hub_data_export_expired',
  'membership_hub_data_export_label',
  'membership_hub_data_export_list_description',
  'membership_hub_data_export_list_empty',
  'membership_hub_data_export_list_title',
  'membership_hub_data_export_pending',
  'membership_hub_data_export_request_failed',
  'membership_hub_data_export_requests_fetch_failed',
  'membership_hub_data_export_title',
  'membership_hub_days_left',
  'membership_hub_download_annual_report',
  'membership_hub_download_invoices',
  'membership_hub_edit_account_info',
  'membership_hub_edit_payment_method',
  'membership_hub_email',
  'membership_hub_email_required_error_message',
  'membership_hub_enter_current_password',
  'membership_hub_enter_email',
  'membership_hub_enter_email_for_reset_link',
  'membership_hub_enter_new_password',
  'membership_hub_enter_password',
  'membership_hub_entitlment_user_member_experience_page_subtitle',
  'membership_hub_essense_plan_detail_description_pending_cancel',
  'membership_hub_experience_card_body_temp',
  'membership_hub_experience_card_heart_rate',
  'membership_hub_experience_card_indepth',
  'membership_hub_experience_card_personalized',
  'membership_hub_experience_subtitle',
  'membership_hub_experience_subtitle_exclusive_promotions',
  'membership_hub_experience_subtitle_features',
  'membership_hub_experience_subtitle_insights',
  'membership_hub_experience_subtitle_latest_and_greatest',
  'membership_hub_experience_text_exclusive_promotions',
  'membership_hub_experience_text_features',
  'membership_hub_experience_text_insights',
  'membership_hub_experience_text_latest_and_greatest',
  'membership_hub_experience_title',
  'membership_hub_experience_title_body',
  'membership_hub_expired_membership',
  'membership_hub_expired_payment_method',
  'membership_hub_expiring_soon',
  'membership_hub_feature_name',
  'membership_hub_finish_onboarding_flow',
  'membership_hub_first_month_on_us',
  'membership_hub_forgot_password',
  'membership_hub_general_error',
  'membership_hub_general_error_return_to_home',
  'membership_hub_inactive_description_get_membership_benefits',
  'membership_hub_introducing_oura_ring_gen3',
  'membership_hub_introducing_oura_ring_gen3_body',
  'membership_hub_introducing_oura_ring_gen4',
  'membership_hub_invalid_password',
  'membership_hub_invoice_compensated',
  'membership_hub_lifetime_membership',
  'membership_hub_login_button',
  'membership_hub_login_failed_error_message',
  'membership_hub_logout',
  'membership_hub_member_experience',
  'membership_hub_member_experience_sub_title',
  'membership_hub_member_since',
  'membership_hub_membership_plan',
  'membership_hub_membership_plan_next_payment',
  'membership_hub_membership_plan_type_annual',
  'membership_hub_membership_plan_type_monthly',
  'membership_hub_membership_setup',
  'membership_hub_membership_terms',
  'membership_hub_moi_error_signup_required',
  'membership_hub_monthly_after_prepaid_text',
  'membership_hub_monthly_plan',
  'membership_hub_monthly_price',
  'membership_hub_monthly_product',
  'membership_hub_monthly_product_plan',
  'membership_hub_monthly_report_list',
  'membership_hub_no_address',
  'membership_hub_no_address_found',
  'membership_hub_no_billing_history',
  'membership_hub_no_payment_method',
  'membership_hub_not_connected_gen2',
  'membership_hub_one_day_left',
  'membership_hub_ongoing_plan',
  'membership_hub_password',
  'membership_hub_password_changed',
  'membership_hub_password_required_error_message',
  'membership_hub_password_reset_successful',
  'membership_hub_payment_details',
  'membership_hub_payment_method',
  'membership_hub_payment_method_subtitle_monthly_price',
  'membership_hub_payment_method_subtitle_yearly_price',
  'membership_hub_payment_method_update_success',
  'membership_hub_payment_method_update_success_body_text',
  'membership_hub_payment_required_description',
  'membership_hub_paypal',
  'membership_hub_plan_confirm_modal_text',
  'membership_hub_prepaid',
  'membership_hub_prepaid_pending_description',
  'membership_hub_prepaid_pending_label',
  'membership_hub_prepaid_subtitle_1',
  'membership_hub_prepaid_subtitle_2',
  'membership_hub_prepaid_title',
  'membership_hub_prepaid_welcome_moment_paragraph_1',
  'membership_hub_prepaid_welcome_moment_paragraph_2',
  'membership_hub_privacy_card_subtitle',
  'membership_hub_privacy_card_title',
  'membership_hub_product_page_plan_info',
  'membership_hub_product_page_prepaid_plan_info',
  'membership_hub_product_page_subtitle',
  'membership_hub_product_page_title',
  'membership_hub_pw_creation_requirement_min_length',
  'membership_hub_pw_creation_requirement_policy',
  'membership_hub_pw_reset_link_expired',
  'membership_hub_pw_reset_link_is_expired',
  'membership_hub_quicklink_export_data',
  'membership_hub_quicklink_heading',
  'membership_hub_quicklink_password',
  'membership_hub_quicklink_payment_details',
  'membership_hub_quicklink_payment_history',
  'membership_hub_renew_legal',
  'membership_hub_renew_membership',
  'membership_hub_renew_notification_body',
  'membership_hub_renew_submit',
  'membership_hub_renew_with_payment',
  'membership_hub_reset_password',
  'membership_hub_reset_password_email_instructions',
  'membership_hub_return_to_hub_home',
  'membership_hub_same_as_billing_address',
  'membership_hub_select_all',
  'membership_hub_send_link_to_email',
  'membership_hub_signup_address_page_title',
  'membership_hub_signup_annual_billing',
  'membership_hub_signup_confirmation_desktop_subtitle',
  'membership_hub_signup_confirmation_mobile_subtitle',
  'membership_hub_signup_confirmation_title',
  'membership_hub_signup_free_price',
  'membership_hub_signup_membership_summary_billing_start_date',
  'membership_hub_signup_membership_summary_title',
  'membership_hub_signup_monthly_billing',
  'membership_hub_signup_payment_method_page_title',
  'membership_hub_signup_payment_method_subtitle',
  'membership_hub_signup_prepaid_applied',
  'membership_hub_signup_product_page_subtitle',
  'membership_hub_signup_product_page_subtitle_prepaid_p1',
  'membership_hub_signup_product_page_subtitle_prepaid_p2',
  'membership_hub_signup_product_page_title',
  'membership_hub_signup_product_subtitle_normal_flow',
  'membership_hub_signup_subtitle',
  'membership_hub_signup_subtitle_prepaid',
  'membership_hub_signup_trial_month',
  'membership_hub_signup_X_month_prepaid_plan',
  'membership_hub_subtitle_prepaid',
  'membership_hub_switch_to_annual_plan',
  'membership_hub_terms_1',
  'membership_hub_terms_2',
  'membership_hub_terms_3',
  'membership_hub_terms_4',
  'membership_hub_terms_5',
  'membership_hub_terms_dialog_support_section',
  'membership_hub_terms_product_selected',
  'membership_hub_terms_product_selected_annual',
  'membership_hub_terms_product_selected_monthly',
  'membership_hub_trial_extended',
  'membership_hub_try_again_error',
  'membership_hub_unverified_account',
  'membership_hub_unverified_account_link_label',
  'membership_hub_upcoming_plan_title',
  'membership_hub_update',
  'membership_hub_update_account_information_text',
  'membership_hub_update_account_information_text_moi_user',
  'membership_hub_update_email',
  'membership_hub_update_email_input',
  'membership_hub_update_membership_password',
  'membership_hub_update_membership_plan_link',
  'membership_hub_update_password',
  'membership_hub_update_payment_info',
  'membership_hub_update_payment_method',
  'membership_hub_update_product_page_subtitle',
  'membership_hub_upgrade_to_gen3',
  'membership_hub_upgrade_to_gen4',
  'membership_hub_use_existing_address',
  'membership_hub_verify_email',
  'membership_hub_verify_email_magic_link_expired',
  'membership_hub_verifying_your_email',
  'membership_hub_view_billing_history',
  'membership_hub_view_membership_plan',
  'membership_hub_view_order_status',
  'membership_hub_view_payment_details_page',
  'membership_hub_welcome',
  'membership_hub_welcome_back',
  'membership_hub_x_month_trial',
  'membership_hub_yearly_after_prepaid_text',
  'membership_hub_yearly_plan',
  'membership_hub_yearly_price',
  'membership_hub_yearly_product',
  'membership_hub_yearly_product_plan',
  'membership_hub_yearly_report_list',
  'membership_member_experience_page_link',
  'membership_moi_login_error',
  'membership_payment_gateway_error',
  'membership_pending_prepaid_months',
  'membership_planselector_badge_most_convenient',
  'membership_reset_password_rate_limit_over',
  'membership_reset_password_user_not_found',
  'membership_setup_ring_pair_failure_notification',
  'membership_setup_signup_token_error',
  'membership_show_password',
  'membership_signup_accessibility',
  'membership_signup_account_created_success_message',
  'membership_signup_account_created_success_message_gen2',
  'membership_signup_account_created_title',
  'membership_signup_account_password_new_password',
  'membership_signup_account_password_title',
  'membership_signup_account_setup_exclusivehealth',
  'membership_signup_account_setup_exclusivehealth.33',
  'membership_signup_account_setup_readandagree',
  'membership_signup_address_subtitle_1',
  'membership_signup_address_subtitle_2',
  'membership_signup_all_rights_reserved',
  'membership_signup_billing_address_address_field',
  'membership_signup_billing_address_address2_field',
  'membership_signup_billing_address_billing_apt',
  'membership_signup_billing_address_billing_state',
  'membership_signup_billing_address_billing_zip',
  'membership_signup_billing_address_city_field',
  'membership_signup_billing_address_country_field',
  'membership_signup_billing_address_enter_address',
  'membership_signup_billing_address_filled_step2',
  'membership_signup_billing_address_first_name_field',
  'membership_signup_billing_address_home_address_required',
  'membership_signup_billing_address_last_name_field',
  'membership_signup_billing_address_physicaladdressrequired',
  'membership_signup_billing_address_title',
  'membership_signup_button_back',
  'membership_signup_button_next',
  'membership_signup_error_unknown',
  'membership_signup_fallback_name',
  'membership_signup_ip_notice',
  'membership_signup_lets_activate',
  'membership_signup_no_prepaid_address_title',
  'membership_signup_payment_disclaimer',
  'membership_signup_payment_method_automaticrenewal',
  'membership_signup_payment_method_button_checkout',
  'membership_signup_payment_method_button_submit',
  'membership_signup_payment_method_CC',
  'membership_signup_payment_method_ccnumber',
  'membership_signup_payment_method_clickbelow',
  'membership_signup_payment_method_creditcard_expiracy_placeholder',
  'membership_signup_payment_method_cvv',
  'membership_signup_payment_method_expirationdate',
  'membership_signup_payment_method_expirationyear',
  'membership_signup_payment_method_link_back',
  'membership_signup_payment_method_name',
  'membership_signup_payment_method_step3',
  'membership_signup_payment_method_subtitle',
  'membership_signup_payment_method_subtitle_monthly_price',
  'membership_signup_payment_method_subtitle_yearly_price',
  'membership_signup_payment_method_title',
  'membership_signup_paypal_checkout_text',
  'membership_signup_physical_address',
  'membership_signup_physical_address_billing_address',
  'membership_signup_planselection_help',
  'membership_signup_prepaid_welcome_moment_paragraph_1',
  'membership_signup_prepaid_welcome_moment_paragraph_2',
  'membership_signup_privacy_policy',
  'membership_signup_privacypolicy_link_text',
  'membership_signup_setup_complete_back_to_app_button',
  'membership_signup_step',
  'membership_signup_support',
  'membership_signup_terms_conditions',
  'membership_signup_termsandconditions_link_text',
  'membership_signup_trademarks',
  'membership_signup_welcome_page_button_getstarted',
  'membership_signup_welcome_page_first_month',
  'membership_signup_welcome_page_subtitle',
  'membership_signup_welcome_page_title',
  'membership_spotlight_b2b_to_d2c_cta',
  'membership_spotlight_b2b_to_d2c_label',
  'membership_spotlight_b2b_to_d2c_partner_fallback',
  'membership_spotlight_b2b_to_d2c_text',
  'membership_spotlight_pending_cancellation_label',
  'membership_spotlight_pending_cancellation_text',
  'membership_spotlight_start_prepaid_label',
  'membership_spotlight_start_prepaid_text',
  'membership-modal-close-button',
  'my_account_export_data_daily_activity',
  'my_account_export_data_daily_readiness',
  'my_account_export_data_daily_sleep',
  'my_account_export_data_daily_spo2',
  'my_account_export_data_datatype',
  'my_account_export_data_daytime_heart_rate',
  'my_account_export_data_ideal_bedtime',
  'my_account_export_data_legacy_format_datatype',
  'my_account_export_data_legacy_format_heading',
  'my_account_export_data_notes_tags',
  'my_account_export_data_sleep',
  'my_account_export_data_smoothed_location',
  'my_account_export_data_text',
  'my_account_title_export_data',
  'payment_method_failrue_invalid_card_number',
  'payment_method_failure_ach_bank_name_required',
  'payment_method_failure_card_holder_name_required',
  'payment_method_failure_card_type_required',
  'payment_method_failure_expiration_date_must_be_future_date',
  'payment_method_failure_inactive_gateway',
  'payment_method_failure_invalid_email',
  'payment_method_failure_invalid_month',
  'payment_method_failure_invalid_year',
  'payment_method_failure_non_iso_state',
  'payment_method_failure_non_numeric_security_code',
  'payment_method_failure_null_ach_bank_account_number',
  'payment_method_failure_null_ach_or_aba_code',
  'payment_method_failure_please_try_another_method',
  'payment_method_failure_too_long_ach_name',
  'payment_method_failure_too_long_ach_number',
  'payment_method_failure_too_many_associations',
  'payment_method_failure_too_many_payment_methods_for_account',
  'pending_cancellation_spotlight_item_subtitle',
  'pending_cancellation_spotlight_item_title',
  'signup_account_setup_banner_default_text',
  'signup_account_setup_banner_prepaid_text',
  'signup_account_setup_default_subtitle',
  'signup_account_setup_prepaid_subtitle',
  'signup_account_setup_title',
  'signup_payment_page_default_subtitle',
  'signup_payment_page_prepaid_subtitle',
  'state_AE_AbuDhabi',
  'state_AE_Ajman',
  'state_AE_Dubai',
  'state_AE_Fujairah',
  'state_AE_RasAlKhaimah',
  'state_AE_Sharjah',
  'state_AE_UmmAlQuwain',
  'state_AU_ACT',
  'state_AU_NSW',
  'state_AU_NT',
  'state_AU_QLD',
  'state_AU_SA',
  'state_AU_TAS',
  'state_AU_VIC',
  'state_AU_WA',
  'state_CA_AB',
  'state_CA_BC',
  'state_CA_MB',
  'state_CA_NB',
  'state_CA_NL',
  'state_CA_NS',
  'state_CA_NT',
  'state_CA_NU',
  'state_CA_ON',
  'state_CA_PE',
  'state_CA_QC',
  'state_CA_SK',
  'state_CA_YT',
  'state_IT_AG',
  'state_IT_AL',
  'state_IT_AN',
  'state_IT_AO',
  'state_IT_AP',
  'state_IT_AQ',
  'state_IT_AR',
  'state_IT_AT',
  'state_IT_AV',
  'state_IT_BA',
  'state_IT_BG',
  'state_IT_BI',
  'state_IT_BL',
  'state_IT_BN',
  'state_IT_BO',
  'state_IT_BR',
  'state_IT_BS',
  'state_IT_BT',
  'state_IT_BZ',
  'state_IT_CA',
  'state_IT_CB',
  'state_IT_CE',
  'state_IT_CH',
  'state_IT_CI',
  'state_IT_CL',
  'state_IT_CN',
  'state_IT_CO',
  'state_IT_CR',
  'state_IT_CS',
  'state_IT_CT',
  'state_IT_CZ',
  'state_IT_EN',
  'state_IT_FC',
  'state_IT_FE',
  'state_IT_FG',
  'state_IT_FI',
  'state_IT_FM',
  'state_IT_FR',
  'state_IT_GE',
  'state_IT_GO',
  'state_IT_GR',
  'state_IT_IM',
  'state_IT_IS',
  'state_IT_KR',
  'state_IT_LC',
  'state_IT_LE',
  'state_IT_LI',
  'state_IT_LO',
  'state_IT_LT',
  'state_IT_LU',
  'state_IT_MB',
  'state_IT_MC',
  'state_IT_ME',
  'state_IT_MI',
  'state_IT_MN',
  'state_IT_MO',
  'state_IT_MS',
  'state_IT_MT',
  'state_IT_NA',
  'state_IT_NO',
  'state_IT_NU',
  'state_IT_OG',
  'state_IT_OR',
  'state_IT_OT',
  'state_IT_PA',
  'state_IT_PC',
  'state_IT_PD',
  'state_IT_PE',
  'state_IT_PG',
  'state_IT_PI',
  'state_IT_PN',
  'state_IT_PO',
  'state_IT_PR',
  'state_IT_PT',
  'state_IT_PU',
  'state_IT_PV',
  'state_IT_PZ',
  'state_IT_RA',
  'state_IT_RC',
  'state_IT_RE',
  'state_IT_RG',
  'state_IT_RI',
  'state_IT_RM',
  'state_IT_RN',
  'state_IT_RO',
  'state_IT_SA',
  'state_IT_SI',
  'state_IT_SO',
  'state_IT_SP',
  'state_IT_SR',
  'state_IT_SS',
  'state_IT_SV',
  'state_IT_TA',
  'state_IT_TE',
  'state_IT_TN',
  'state_IT_TO',
  'state_IT_TP',
  'state_IT_TR',
  'state_IT_TS',
  'state_IT_TV',
  'state_IT_UD',
  'state_IT_VA',
  'state_IT_VB',
  'state_IT_VC',
  'state_IT_VE',
  'state_IT_VI',
  'state_IT_VR',
  'state_IT_VS',
  'state_IT_VT',
  'state_IT_VV',
  'state_JP_JP-01',
  'state_JP_JP-02',
  'state_JP_JP-03',
  'state_JP_JP-04',
  'state_JP_JP-05',
  'state_JP_JP-06',
  'state_JP_JP-07',
  'state_JP_JP-08',
  'state_JP_JP-09',
  'state_JP_JP-10',
  'state_JP_JP-11',
  'state_JP_JP-12',
  'state_JP_JP-13',
  'state_JP_JP-14',
  'state_JP_JP-15',
  'state_JP_JP-16',
  'state_JP_JP-17',
  'state_JP_JP-18',
  'state_JP_JP-19',
  'state_JP_JP-20',
  'state_JP_JP-21',
  'state_JP_JP-22',
  'state_JP_JP-23',
  'state_JP_JP-24',
  'state_JP_JP-25',
  'state_JP_JP-26',
  'state_JP_JP-27',
  'state_JP_JP-28',
  'state_JP_JP-29',
  'state_JP_JP-30',
  'state_JP_JP-31',
  'state_JP_JP-32',
  'state_JP_JP-33',
  'state_JP_JP-34',
  'state_JP_JP-35',
  'state_JP_JP-36',
  'state_JP_JP-37',
  'state_JP_JP-38',
  'state_JP_JP-39',
  'state_JP_JP-40',
  'state_JP_JP-41',
  'state_JP_JP-42',
  'state_JP_JP-43',
  'state_JP_JP-44',
  'state_JP_JP-45',
  'state_JP_JP-46',
  'state_JP_JP-47',
  'state_US_AA',
  'state_US_AE',
  'state_US_AK',
  'state_US_AL',
  'state_US_AP',
  'state_US_AR',
  'state_US_AS',
  'state_US_AZ',
  'state_US_CA',
  'state_US_CO',
  'state_US_CT',
  'state_US_DC',
  'state_US_DE',
  'state_US_FL',
  'state_US_GA',
  'state_US_GU',
  'state_US_HI',
  'state_US_IA',
  'state_US_ID',
  'state_US_IL',
  'state_US_IN',
  'state_US_KS',
  'state_US_KY',
  'state_US_LA',
  'state_US_MA',
  'state_US_MD',
  'state_US_ME',
  'state_US_MI',
  'state_US_MN',
  'state_US_MO',
  'state_US_MP',
  'state_US_MS',
  'state_US_MT',
  'state_US_NC',
  'state_US_ND',
  'state_US_NE',
  'state_US_NH',
  'state_US_NJ',
  'state_US_NM',
  'state_US_NV',
  'state_US_NY',
  'state_US_OH',
  'state_US_OK',
  'state_US_OR',
  'state_US_PA',
  'state_US_PR',
  'state_US_RI',
  'state_US_SC',
  'state_US_SD',
  'state_US_TN',
  'state_US_TX',
  'state_US_UT',
  'state_US_VA',
  'state_US_VI',
  'state_US_VT',
  'state_US_WA',
  'state_US_WI',
  'state_US_WV',
  'state_US_WY',
  'membership_hub_ending_on_date',
  'membership_hub_membership_update_success',
] as const;

export type MessageKey = (typeof messageKeys)[number];
